var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGhana(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_877_1763)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 16.479C0 18.4948 0.362601 20.4256 1.02498 22.2108L16.4789 22.9273L31.9329 22.2109C32.5953 20.4256 32.9579 18.4948 32.9579 16.479C32.9579 14.4633 32.5953 12.5325 31.9329 10.7473L16.4789 10.0308L1.02498 10.7472C0.362601 12.5325 0 14.4633 0 16.479H0Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4789 0C9.39349 0 3.35326 4.47197 1.0249 10.7472H31.9329C29.6044 4.47197 23.5642 0 16.4789 0V0Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9328 22.2109H1.0249C3.35326 28.4861 9.39349 32.9581 16.4789 32.9581C23.5642 32.9581 29.6044 28.4861 31.9328 22.2109Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4788 10.7471L17.9014 15.1256H22.5057L18.781 17.8319L20.2036 22.2106L16.4788 19.5045L12.754 22.2106L14.1768 17.8319L10.4521 15.1256H15.0562L16.4788 10.7471Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_877_1763"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32.9579,
    height: 32.9579,
    rx: 4,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGhana);
export default __webpack_public_path__ + "static/media/ghana.863ba4705341a498da3da662015ddc94.svg";
export { ForwardRef as ReactComponent };